import { createContext } from 'react'

export const ContextLayout = createContext()
